/**
 * IDs de portal según backend de publicaciones.
 * Si falta algún id, se muestra "-".
 */
const PORTAL_ID_TO_NAME: Record<number, string> = {
  31: 'Chileautos',
};

export function getPortalNameFromId(portalId: number): string {
  return PORTAL_ID_TO_NAME[portalId] ?? '-';
}

/** Texto legible para motivo_inv; ampliar cuando el backend documente los códigos. */
const INVALID_REASON_LABELS: Record<number, string> = {
  1: 'No identificadas',
  2: 'Pub. con observaciones críticas',
  3: 'Pub. de zona extrema',
  4: 'Precio no cumple requisitos',
  5: 'Publicación expirada',
  6: 'Publicación duplicada',
  7: 'Precio fuera de rango de mercado',
  8: 'Precio fuera de rango de mercado',
  9: 'Publicación de leasing',
};

export function getInvalidReasonLabel(motivoInv: number): string {
  return INVALID_REASON_LABELS[motivoInv] ?? `Código ${motivoInv}`;
}
